import { Component, Input } from '@angular/core';
import subcategoryDescription from '../../../../assets/subcategory-descriptions/subcategory-descriptions.json';
import { PrimeNGModule } from '../../../primeng.module';
import InfoSubCategory from '../../models/product/info-sub-category';
import { SharedModule } from '../../shared.module';

export class SubcategoryDescription {
  public id?: string;
  public descriptions?: SubcategoryDescriptionItem;
}

export class SubcategoryDescriptionItem {
  public title?: string;
  public text?: string;
  public sections?: SubcategoryDescriptionSectionItem[];
}

export class SubcategoryDescriptionSectionItem {
  public subtitle?: string;
  public text?: string;
}

@Component({
  selector: 'app-subcategory-description',
  standalone: true,
  imports: [SharedModule, PrimeNGModule],
  templateUrl: './subcategory-description.component.html',
  styleUrl: './subcategory-description.component.scss',
})
export class SubcategoryDescriptionComponent {
  @Input()
  public set subCategory(subCategory: InfoSubCategory | undefined) {
    if (subCategory) {
      this.setDescription(subCategory);
    }
  }

  public subSelected?: SubcategoryDescriptionItem;

  setDescription(subCategory: InfoSubCategory) {
    this.subSelected = undefined;
    if (subcategoryDescription) {
      let sub = subcategoryDescription.find(
        (info) => info.id === subCategory.id
      );

      if (sub) {
        const info: SubcategoryDescription = Object.assign(
          new SubcategoryDescription(),
          sub
        );
        this.subSelected = info.descriptions;
      }
    }
  }
}
